import React from 'react';
import {Card} from '../../../../_metronic/_partials/controls';
import {UsersActionsFilter} from './UsersActionsFilter.js';
import {UsersActionsTable} from './UsersActionsTable';
import {UsersActionsFooter} from './UsersActionsFooter';
import FooterBar from '../../_common/components/FooterBar';

export function UsersActionsCard() {

  return (
    <Card className={'flex-fill bg-transparent shadow-none'} id={'users-actions-list-card'}>
      <UsersActionsFilter/>
      <UsersActionsTable/>
      <FooterBar>
        <UsersActionsFooter/>
      </FooterBar>
    </Card>
  );
}
